import { useCallback } from "react";
import { formatCurrency, sanitizeNumberInput } from "../../../../utils/format";

export const useCurrencyFormat = (formData, setFormData) => {
  const handleCurrencyBlur = useCallback(
    (field) => {
      const raw = String(formData[field] || "").trim();
      const cleaned = sanitizeNumberInput(raw, "");
      setFormData((p) => ({
        ...p,
        [field]: cleaned ? formatCurrency(cleaned) : "",
      }));
    },
    [formData, setFormData]
  );

  return handleCurrencyBlur;
};

